/**
 * アイコンとして選べる絵文字(ユーザー要望 2026-09-16)。
 * 絵文字ピッカーのように種類でタブを分けるため、カテゴリと日本語の名前(検索用)を持つ。
 * ライブラリを足さずに済むよう、よく使いそうなものを手で選んでいる。
 */
export const EMOJI_CATEGORIES = [
  "よく使う",
  "顔",
  "人",
  "自然",
  "食べ物",
  "活動",
  "場所",
  "もの",
  "記号",
] as const;
export type EmojiCategory = (typeof EMOJI_CATEGORIES)[number];

export interface EmojiChoice {
  /** そのまま icon に保存する */
  value: string;
  /** 検索と読み上げに使う名前 */
  title: string;
  category: EmojiCategory;
}

const e = (value: string, title: string, category: EmojiCategory): EmojiChoice => ({
  value,
  title,
  category,
});

export const EMOJI_CHOICES: EmojiChoice[] = [
  e("📝", "メモ", "よく使う"),
  e("📧", "メール", "よく使う"),
  e("📄", "書類", "よく使う"),
  e("📁", "フォルダ", "よく使う"),
  e("📊", "グラフ", "よく使う"),
  e("📅", "カレンダー", "よく使う"),
  e("💬", "チャット", "よく使う"),
  e("🔗", "リンク", "よく使う"),
  e("⭐", "星", "よく使う"),
  e("✅", "チェック", "よく使う"),
  e("📌", "ピン", "よく使う"),
  e("🏠", "家", "よく使う"),
  e("🔍", "検索", "よく使う"),

  e("😀", "笑顔", "顔"),
  e("😄", "うれしい", "顔"),
  e("🙂", "微笑み", "顔"),
  e("😉", "ウインク", "顔"),
  e("😊", "にこにこ", "顔"),
  e("🤔", "考える", "顔"),
  e("😅", "苦笑い", "顔"),
  e("😢", "泣く", "顔"),
  e("😡", "怒り", "顔"),
  e("😴", "眠い", "顔"),
  e("🤝", "握手", "顔"),
  e("👍", "いいね", "顔"),
  e("👏", "拍手", "顔"),
  e("🙏", "お願い", "顔"),
  e("💪", "力こぶ", "顔"),
  e("✍️", "書く", "顔"),

  e("👤", "人", "人"),
  e("👥", "人々", "人"),
  e("👨‍💻", "開発者", "人"),
  e("👷", "作業員", "人"),
  e("🧑‍🏫", "先生", "人"),
  e("🧑‍🔧", "技術者", "人"),
  e("🧑‍💼", "会社員", "人"),
  e("👶", "赤ちゃん", "人"),
  e("🧑‍🤝‍🧑", "チーム", "人"),
  e("🗣️", "話す人", "人"),

  e("🌱", "芽", "自然"),
  e("🌳", "木", "自然"),
  e("🌸", "花", "自然"),
  e("🍀", "四つ葉", "自然"),
  e("🌞", "太陽", "自然"),
  e("🌙", "月", "自然"),
  e("⭐️", "星空", "自然"),
  e("☁️", "雲", "自然"),
  e("⚡", "稲妻", "自然"),
  e("🔥", "炎", "自然"),
  e("💧", "水", "自然"),
  e("🌊", "波", "自然"),
  e("🐶", "犬", "自然"),
  e("🐱", "猫", "自然"),
  e("🐢", "亀", "自然"),
  e("🐝", "蜂", "自然"),

  e("🍙", "おにぎり", "食べ物"),
  e("🍜", "ラーメン", "食べ物"),
  e("🍣", "寿司", "食べ物"),
  e("🍞", "パン", "食べ物"),
  e("🍰", "ケーキ", "食べ物"),
  e("🍎", "りんご", "食べ物"),
  e("☕", "コーヒー", "食べ物"),
  e("🍵", "お茶", "食べ物"),
  e("🍺", "ビール", "食べ物"),
  e("🥗", "サラダ", "食べ物"),

  e("🚀", "ロケット", "活動"),
  e("🎯", "的", "活動"),
  e("🎉", "祝い", "活動"),
  e("🎨", "絵", "活動"),
  e("🎓", "卒業", "活動"),
  e("🏆", "トロフィー", "活動"),
  e("⚽", "サッカー", "活動"),
  e("🎮", "ゲーム", "活動"),
  e("🎵", "音楽", "活動"),
  e("📣", "アナウンス", "活動"),
  e("🧪", "実験", "活動"),
  e("🛠️", "工具", "活動"),

  e("🏢", "ビル", "場所"),
  e("🏭", "工場", "場所"),
  e("🏫", "学校", "場所"),
  e("🏪", "店", "場所"),
  e("🗾", "日本", "場所"),
  e("🌏", "地球", "場所"),
  e("🚗", "車", "場所"),
  e("🚃", "電車", "場所"),
  e("✈️", "飛行機", "場所"),
  e("🗺️", "地図", "場所"),

  e("💻", "パソコン", "もの"),
  e("🖥️", "デスクトップ", "もの"),
  e("📱", "スマホ", "もの"),
  e("⌨️", "キーボード", "もの"),
  e("🖨️", "プリンター", "もの"),
  e("💾", "保存", "もの"),
  e("🗄️", "書庫", "もの"),
  e("📦", "箱", "もの"),
  e("📚", "本", "もの"),
  e("📒", "ノート", "もの"),
  e("📋", "クリップボード", "もの"),
  e("📎", "クリップ", "もの"),
  e("✏️", "鉛筆", "もの"),
  e("🔑", "鍵", "もの"),
  e("🔒", "ロック", "もの"),
  e("🔔", "ベル", "もの"),
  e("💡", "電球", "もの"),
  e("🧭", "方位磁針", "もの"),
  e("⏰", "時計", "もの"),
  e("💰", "お金", "もの"),
  e("🧾", "領収書", "もの"),
  e("📮", "ポスト", "もの"),
  e("✉️", "封筒", "もの"),
  e("🎥", "ビデオ", "もの"),
  e("📷", "カメラ", "もの"),
  e("🎬", "動画", "もの"),
  e("🗃️", "カードボックス", "もの"),
  e("🖇️", "書類まとめ", "もの"),

  e("❗", "注意", "記号"),
  e("❓", "疑問", "記号"),
  e("⚠️", "警告", "記号"),
  e("🚧", "工事中", "記号"),
  e("🆕", "新着", "記号"),
  e("🆗", "OK", "記号"),
  e("🔴", "赤丸", "記号"),
  e("🟠", "橙丸", "記号"),
  e("🟡", "黄丸", "記号"),
  e("🟢", "緑丸", "記号"),
  e("🔵", "青丸", "記号"),
  e("🟣", "紫丸", "記号"),
  e("⬛", "黒", "記号"),
  e("⬜", "白", "記号"),
  e("♻️", "リサイクル", "記号"),
  e("©️", "著作権", "記号"),
  e("#️⃣", "ハッシュ", "記号"),
  e("➡️", "右矢印", "記号"),
  e("🔄", "更新", "記号"),
  e("🔕", "通知オフ", "記号"),
];
